











import { Component, Vue } from 'vue-property-decorator';
import { Getter } from 'vuex-class';
import { PublishedApp } from '../shared/models';
import { googleBmApi } from './services/googlebmApi';
import WorkspaceViewModel from '@/workspaces/models/workspaceViewModel';
import { GoogleBmInstalledApp } from './models';
import GoogleBmAddAgent from './components/GoogleBmAddAgent.vue';
import GoogleBmAgentList from './components/GoogleBmAgentList.vue';
import {GoogleBmAgent} from '@/features/apps/googlebm/models/googleBmAgent';
import Toast from '@/shared/services/toast';

@Component({
	components: {
		GoogleBmAddAgent,
		GoogleBmAgentList
	}
})
export default class GoogleBmConfig extends Vue {
	@Getter public currentApp!: PublishedApp;
	@Getter public currentWorkspace!: WorkspaceViewModel;

	public hasLoaded = false;

	public app: GoogleBmInstalledApp | null = null;
	public agents: GoogleBmAgent[] = [];

	public created() {
		this.loadApp();
	}

	public isInstalled() {
		return this.app !== null && this.app.agents && this.app.agents.length > 0;
	}

	public async configSaved() {
		try {
			this.app = await googleBmApi.getInstalledApp(this.currentWorkspace.id);
			this.agents = this.app.agents;
		} catch (err) {
			Toast.showError(`Failed to load app: ${err.message}`);
		}
		this.$emit('configSaved', true);
	}

	private async loadApp() {
		if (this.currentApp.isInstalled) {
			try {
				this.app = await googleBmApi.getInstalledApp(this.currentWorkspace.id);
				this.agents = this.app.agents;
			} catch (err) {
				if (err.status !== 404) {
					// show error state...
				}
			} finally {
				this.hasLoaded = true;
				this.$emit('loaded');
			}
		} else {
			this.$emit('loaded');
		}
	}
}
